export default "__VITE_ASSET__CUbGsgxi__"